import { api } from "../utils/axios";

export interface LeaveType {
  _id: string;
  code: string;
  label: string;
}

export const getLeaveTypes = async (): Promise<LeaveType[]> => {
  try {
    const { data, ok } = await api.get("/leave-types");
    if (ok) return (data as any)?.leaveTypes ?? [];
  } catch {}
  return [];
};
